import React, { useCallback, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { saveAccessTokens } from '@ecp/common/src/utils/utils';

import authApi from '@mo-apis/common/authApi';
 

const GuestRoutes = () => {
  const navigate = useNavigate();

  const guestLogin = useCallback(async () => {
 
    const {
      data: { guestAccessToken, refreshToken },
    }  = await authApi.guestLogin({});
    
    if(guestAccessToken) {
      saveAccessTokens(guestAccessToken, refreshToken);
      navigate(0);
    } else {
      return false;
    }
  }, []);

  useEffect(() => {
    (async () => guestLogin())();
  }, [guestLogin]);

  return <></>;
};

export default GuestRoutes;